if (!customElements.get('resize-matcher')) {
    class ResizeMatcher extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            if (this.dataset.useWindow){
                AttachWindowResizeObserver(this)
            }else {
                AttachResizeObserver(this)
            }
            this.OnResize()
        }
        OnResize(entry) {
            // This Gets called by the Global AttachResizeObserver Function
            if(this.dataset.axis === "Horizontal") {
                this.style.width = `var(--${this.dataset.variable})`
            } else {
                this.style.height = `var(--${this.dataset.variable})`
            }
        }
    }

    customElements.define('resize-matcher', ResizeMatcher);
}